import React from "react";
import Image from "../../../elements/Image";
import StoryImage from "../../../../assets/image/image-story.webp";
import { useBanner } from "../../../../providers/BannerProviders";

const Story = () => {
  const { data } = useBanner();
  const vpetersBanner = data?.data?.find(
    (item) => item?.bannerType === "v'Peters"
  );

  const storyData = {
    title: "Our Story",
    description:
      "Welcome to V’peters family scholarship, where knowledge meets inspiration, and every individual’s educational journey is valued. Established in 1971 Establishment, our university has been a bastion of learning, innovation, and community for 51 years years.",
    image: vpetersBanner?.details?.firstSubSection?.image?.url,
    statistics: [
      vpetersBanner?.details?.firstSubSection,
      vpetersBanner?.details?.secondSubSection,
      vpetersBanner?.details?.thirdSubSection,
    ],
  };

  return (
    <>
      {storyData && (
        <section className="relative flex w-full bg-white">
          <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
            <div className="divide-y divide-shades-05/50">
              <div className="md:flex py-16 sm:py-24">
                <div className="flex flex-shrink-0 items-center py-4 pr-12 md:w-1/4 justify-center md:justify-start">
                  {vpetersBanner?.contentTitle && (
                    <h2 className="text-3xl sm:text-4xl xls:text-[42px] font-bold text-center">
                      {vpetersBanner?.contentTitle}
                    </h2>
                  )}
                </div>
                <div className="flex flex-shrink flex-grow items-center py-4 pl-5 md:pl-12 md:border-l border-shades-05/50">
                  {vpetersBanner?.contentDescription && (
                    <div
                      className="text-base xls:text-lg font-Gotham font-medium"
                      dangerouslySetInnerHTML={{
                        __html: vpetersBanner?.contentDescription,
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="relative w-full grid grid-cols-1 md:grid-cols-2 gap-0 xls:gap-12 py-16 xls:py-24">
                <div className="w-full flex flex-shrink-0">
                  {storyData?.image && (
                    <div className="w-full overflow-hidden">
                      <Image
                        src={storyData?.image}
                        alt={""}
                        effect="blur"
                        classes="object-cover"
                      />
                    </div>
                  )}
                </div>
                <div className="flex flex-col gap-4">
                  {storyData?.statistics?.length > 0 &&
                    storyData?.statistics?.map((item, index) => (
                      <div
                        className="relative flex-shrink flex-grow flex items-center bg-chestnut-rose text-white py-4 px-11 xls:px-16"
                        key={index}
                      >
                        <div className="space-y-4">
                          {item?.count && (
                            <div className="text-2xl md:text-3xl xls:text-7xl xl:text-[86px] leading-none font-bold font-CanelaDeck">
                              {item?.count}
                            </div>
                          )}
                          {item?.title && (
                            <div className="text-lg font-Gotham font-medium">
                              {item?.title}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Story;
